import React, { FunctionComponent, ReactNode } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Typography from '@gojob/ui-bits/Typography';
import { CheeryTitleProps } from '../../../CheeryTitle';

export type TitleProps = {
  level?: CheeryTitleProps['as'];
  children: ReactNode;
};

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();
  return {
    root: {
      marginTop: spacing(2),
      [breakpoint.up('md')]: {
        marginTop: spacing(2),
      },
    },
  };
};

const Title: FunctionComponent<TitleProps> = (props) => {
  const { level, children } = props;
  const classes = useStyles();

  return (
    <Typography css={classes.root} variant="headline1" as={level} color="white">
      {children}
    </Typography>
  );
};

export default Title;
